/**
* Created by vouill on 3/30/18.
*/

<template>
  <div class="author">
    <router-link :to="`/intervenants/${authorMeta.slug}`">{{ authorMeta.firstname }} {{ authorMeta.lastname }}</router-link>
  </div>
</template>

<style scoped >
.author {
  padding-right: 1em;
}
</style>

<script>
import { getEntry } from "../../../utils/contentful";

export default {
  name: "Author",
  props: { author: Object, data: Object },
  computed: {
    authorMeta() {
      return getEntry(this.data.includes, this.author.sys.id).fields;
    }
  }
};
</script>
